import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import { DatePicker } from '@mui/x-date-pickers';
import { adminSlice } from 'common/store/admin';
import { projectSlice } from 'common/store/projects';
import { AppState, appStore, submissionSelector } from 'common/store/store';
import { submissionSlice } from 'common/store/submissions';
import { DateTime } from 'luxon';
import { newProjectFromSubmission, Project } from 'models/projects';
import { Submission, SUBMISSION_STATUS } from 'models/submission';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasErrors } from '../../common/enums';
import { postData } from '../api';


export const AcceptSubmission = (props: { id: ModelId, onClose: (open: number) => void; }) => {

    const submission = useSelector((state: AppState) => submissionSelector.selectById(state, props.id));
    const newProject = useSelector((state: AppState) => state.admin.newProject);
    const user = useSelector((state: AppState) => state.device.user);

    const [price, setPrice] = React.useState('');
    const [archive, setArchive] = React.useState(false);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();

    React.useEffect(() => {
        const f = parseFloat(price);
        appStore.dispatch(adminSlice.actions.updateNewProject({ price: f ?? null }));
    }, [price]);

    React.useEffect(() => {
        if (submission) {
            appStore.dispatch(adminSlice.actions.updateNewProject({
                ...newProjectFromSubmission(submission),
                franchiseId: user?.franchiseId ?? null,
                debutTravaux: null
            }));
            setPrice('');
        }
    }, [props.id]);

    const handleChange = (newValue: any) => {
        appStore.dispatch(adminSlice.actions.updateNewProject({ debutTravaux: (newValue as DateTime).toFormat('yyyy-LL-dd') }));
    };


    const onAccepterClick = async () => {
        const response = await postData<Project>('projects', newProject);
        if (hasErrors(response)) {
            setErr(response);
        } else {
            await postData<Submission>('submissions', {
                id: props.id,
                status: SUBMISSION_STATUS.ACCEPTE,
                archived: archive
            });

            (window as any).dataLayer.push({
                'event': 'soumission_acceptee',
                'transaction_id': submission?.hash ?? 'noid-' + (new Date().toString()),
                'conversionValue': 100,
                'gclid': submission?.gclid
            });

            appStore.dispatch(submissionSlice.actions.updateOne({ id: props.id, changes: { status: SUBMISSION_STATUS.ACCEPTE } }));
            appStore.dispatch(projectSlice.actions.addOne(response));
            props.onClose(0);

        }
    };

    return <Dialog open={!!props.id} onClose={() => props.onClose(0)}>
        <DialogTitle>{'Projet accepté par le client'}</DialogTitle>
        <DialogContent>
            <DialogContentText>
                Un projet sera créé à partir de cette soumission. Celle-ci sera archivée.
            </DialogContentText>
            <Box sx={{ p: 1 }}>
                <TextField
                    label={'Prix de vente'}
                    fullWidth
                    value={price}
                    onChange={(event) => {
                        setPrice(event.target.value);
                    }}
                    type='number'
                    required
                    size='small'
                    error={!!err?.find(p => p.param == 'price')}
                    helperText={err?.find(p => p.param == 'price')?.msg}
                    placeholder='0.00' />
            </Box>
            <Box sx={{ p: 1 }}>
                <DatePicker
                    label={'Date prévu des travaux'}
                    value={newProject.debutTravaux}
                    renderInput={(params) => <TextField {...params} />}
                    onChange={handleChange}
                />
            </Box>
            <Box sx={{ p: 1 }}>
                <FormControlLabel control={<Checkbox checked={archive} onChange={() => setArchive(p => !p)} />} label="archiver la soumission" />
            </Box>
            <DialogActions>
                <Button onClick={() => props.onClose(0)}>Annuler</Button>
                <Button variant='contained' onClick={onAccepterClick} autoFocus>
                    Accepter
                </Button>
            </DialogActions>
        </DialogContent>
    </Dialog>;
};
